import { enteteTenant } from "../../../utils/enteteTenant";
// 🔴 ETI-82 — client HTTP des écrans RÉGIE (liens commerciaux + mon-lien).
//
// 🔑 ⛔ N'appelle QUE `/api/regie/*`. L'empreinte sha256 reste l'autorité côté
//    serveur ; le lien en clair rendu ici vient du déchiffrement SERVEUR réservé
//    (admin + titulaire) — ⛔ le front ⛔ ne déchiffre rien, il AFFICHE ce que le
//    serveur a le droit de lui rendre.
const API = process.env.REACT_APP_BACKEND_URL || "";
const e = encodeURIComponent;

function entetes(tenantId) {
  let jeton = null;
  try { jeton = localStorage.getItem("session_token"); } catch { /* indisponible */ }
  return {
    "Content-Type": "application/json",
    ...enteteTenant(tenantId),
    ...(jeton && { Authorization: `Bearer ${jeton}` }),
  };
}

async function appel(chemin, tenantId, options = {}) {
  const r = await fetch(`${API}${chemin}`, {
    credentials: "include",
    headers: entetes(tenantId),
    ...options,
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) {
    const d = j?.detail;
    throw new Error(typeof d === "string" ? d : `Échec (HTTP ${r.status})`);
  }
  return j;
}

// ── ADMIN ─────────────────────────────────────────────────────────────────────
export const listerLiens = (tenantId, operationCode) =>
  appel(`/api/regie/admin/liens${operationCode ? `?operation_code=${e(operationCode)}` : ""}`, tenantId);

export const listerCommerciaux = (tenantId) =>
  appel("/api/regie/admin/commerciaux", tenantId);

export const listerOperations = (tenantId) =>
  appel("/api/regie/admin/operations", tenantId);

export const emettreLien = (tenantId, commercial_id, operation_code) =>
  appel("/api/regie/admin/liens", tenantId, {
    method: "POST",
    body: JSON.stringify({ commercial_id, operation_code }),
  });

export const revoquerLien = (tenantId, empreinte) =>
  appel(`/api/regie/admin/liens/${e(empreinte)}/revoquer`, tenantId, { method: "POST" });

// ── TITULAIRE (commercial) ──────────────────────────────────────────────────────
export const monLien = (tenantId, operationCode) =>
  appel(`/api/regie/mon-lien${operationCode ? `?operation_code=${e(operationCode)}` : ""}`, tenantId);

// ── SUIVI DOSSIER read-only d'un prospect (commercial) ──────────────────────────
export const dossierProspect = (tenantId, prospectId) =>
  appel(`/api/metier/prospects/${e(prospectId)}/dossier`, tenantId);
